var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsAtom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 359,
    height: 354,
    viewBox: "0 0 359 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M242.824 286.963C265.407 273.925 255.268 214.082 220.176 153.3C185.085 92.518 138.33 53.8141 115.747 66.8523C93.1633 79.8905 103.303 139.733 138.394 200.515C173.486 261.297 220.24 300.001 242.824 286.963Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.315 224.081C249.499 224.08 306.395 202.94 306.394 176.863C306.394 150.786 249.498 129.647 179.314 129.648C109.129 129.649 52.2341 150.789 52.2344 176.866C52.2348 202.943 109.131 224.082 179.315 224.081Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.776 286.957C138.36 299.995 185.116 261.291 220.209 200.509C255.302 139.726 265.442 79.8818 242.859 66.8431C220.275 53.8043 173.519 92.5085 138.426 153.291C103.333 214.074 93.1922 273.918 115.776 286.957Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.686 191.846C178.94 196.611 189.495 193.783 194.26 185.529C199.026 177.275 196.198 166.72 187.944 161.955C179.69 157.189 169.135 160.017 164.37 168.272C159.604 176.526 162.432 187.08 170.686 191.846Z",
    fill: "#FFDB80",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsAtom);
export default __webpack_public_path__ + "static/media/news-atom.54b63558a750acc28c01f0b3c8b8c50b.svg";
export { ForwardRef as ReactComponent };